import { isEmpty, isString } from 'lodash/lang';

import { appInfo } from '../../root';

import { calcDialCodeLength, getDialCode } from './index';

export function normalizePhoneNumber(raw, countryId) {
  if (['US', 'CA'].includes(countryId)) {
    return usOrCaNormalization(raw);
  }

  const ccLength = calcDialCodeLength(countryId);
  return universalNormalization(raw, ccLength);
}

function universalNormalization(raw, ccLength) {
  if (!raw || typeof raw !== 'string' || ccLength < 1) {
    return '';
  }

  const onlyDigits = raw.replace(/\D/g, '');
  const maxDigits = 15 - ccLength;
  if (onlyDigits.length === 0) {
    return '';
  }

  const cappedDigits = onlyDigits.slice(0, maxDigits);
  let filteredRest = '';

  for (let i = 0, numIndex = 0; i < raw.length && numIndex < maxDigits; i++) {
    const c = raw[i];
    if (/\d/.test(c)) {
      if (c === cappedDigits[numIndex]) {
        filteredRest += c;
        numIndex++;
      }
    } else if (c === ' ' || c === '-') {
      filteredRest += c;
    }
  }

  return filteredRest.replace(/([ -]){2,}/g, '-').replace(/^([ -])*0/, match => match.replace(/0$/, ''));
}

function usOrCaNormalization(value) {
  if (!value) {
    return value;
  }

  const currentValue = value.replace(/[^\d]/g, ''),
    cvLength = currentValue.length;

  if (cvLength < 4) {
    return currentValue;
  }

  if (cvLength < 7) {
    return `${currentValue.slice(0, 3)}-${currentValue.slice(3)}`;
  }
  return `${currentValue.slice(0, 3)}-${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
}

export function validatePhoneNumber(countryId, nationalNumber) {
  if (!isEmpty(nationalNumber)) {
    const totalLength = calcPhoneNumberLength(countryId, nationalNumber);
    if (['US', 'CA'].includes(countryId) && totalLength !== 11) {
      return 'Too short, min 11 chars';
    }
    if (totalLength < 8) {
      return 'Too short, min 8 chars';
    }
    if (totalLength > 15) {
      return 'Too long, max 15 chars';
    }
  }
  return null;
}

export function calcPhoneNumberLength(countryId, nationalNumber) {
  const dialCodeLength = calcDialCodeLength(countryId);
  const nationalNumberLength = calcNationalNumberLength(nationalNumber);
  return dialCodeLength + nationalNumberLength;
}

export function calcNationalNumberLength(nationalNumber) {
  return serializePhoneNumber(nationalNumber)?.length || 0;
}

export function serializePhoneNumber(value) {
  if (isString(value)) {
    return value.replace(/[^0-9]/g, '') || null;
  }
  return null;
}

export function formatPhoneNumber(nationalNumber, countryId) {
  const notUsInstance = appInfo.features?.notUsInstance;
  const formattedPhoneNumber = normalizePhoneNumber(nationalNumber, countryId);
  return `${formatDialCode(notUsInstance ? getDialCode(countryId) : null)}${formattedPhoneNumber}`;
}

export function formatDialCode(dialCode) {
  if (dialCode) {
    return `+${dialCode} `;
  }
  return '';
}
